import { LCDClient } from "@terra-money/terra.js";
import Config from "config";

export var SingletonLCD = (function () {
    var instance: LCDClient;
    const createInstance = () => {
        const customLCD = new LCDClient({
          URL: Config.lcdTerraUrl,
          chainID: Config.lcdTerraChainID,
        });
        return customLCD
      }

    return {
        getInstance: function () {
            if (!instance) {
                instance = createInstance();
            }
            return instance;
        }
    };
})();